import React from 'react';
import { useNavigate } from 'react-router-dom';
import { FeedBadge } from './FeedBadge';
import { formatRelativeTime } from '../../hooks/use-relative-time';
import styles from './ProjectFeedCard.module.css';

type ProjectFeedCardProps = {
  readonly projectId: string;
  readonly name: string;
  readonly category: string;
  readonly forecasts: number;
  readonly verifications: number;
  readonly timestamp: string;
};

const ProjectFeedCard = ({ projectId, name, category, forecasts, verifications, timestamp }: ProjectFeedCardProps): React.ReactElement => {
  const navigate = useNavigate();

  return (
    <div
      className={styles.card}
      onClick={(): void => { void navigate(`/project/${projectId}`); }}
      role="link"
      tabIndex={0}
      data-testid="project-card"
    >
      <FeedBadge type="project" />
      <div className={styles.headline}>{name}</div>
      <div className={styles.meta}>
        <span>{category}</span>
        <span className={styles.sep}>·</span>
        <span>{forecasts} forecasts</span>
        <span className={styles.sep}>·</span>
        <span>{verifications} verifications</span>
        <span className={styles.sep}>·</span>
        <span>{formatRelativeTime(timestamp)}</span>
      </div>
    </div>
  );
};

export { ProjectFeedCard };
